(function () {
    'use strict';

    a3_cabin_reports.controller('CrewRouteCtrl', CrewRouteCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name CrewRouteCtrl
     * @description 
     * Shows the crew route information
     * @ngInject
     */
    function CrewRouteCtrl($scope, $filter, $route, $location, $routeParams, $uibModal, FlightFactory,  SyncLogFactory, GroundDutyFactory, CrewRouteFactory) {
        var dutyNo = $routeParams.dutyNo;
        var dutyDay = $routeParams.dutyDay;
        $scope.crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(dutyNo, dutyDay);
    
        var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(dutyNo, dutyDay);
        if(groundDuties.length > 0){    //there are ground duties in this crew route
            angular.forEach(groundDuties, function(groundDuty)
            {
                groundDuty.DutyType = "Ground";
                groundDuty.Start = groundDuty.DutyBegin;
            });
        }

        var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay);
        if(flights.length > 0){    //there are flights in this crew route
            angular.forEach(flights, function(flight)
            {
                flight.DutyType = "Flight";
                flight.Start = flight.ScheduledDeparture;
            });
        }

        var crewRoute = groundDuties.concat(flights);
        crewRoute = $filter('orderBy')(crewRoute, 'Start', false);
        $scope.crewRoute = crewRoute;
        $scope.currentDutyDay = null;
        $scope.differentDay = differentDay;
        $scope.currentPage = 1;
        $scope.previous = previous;
        $scope.next = next;
        $scope.openRefresh = openRefresh;
        $scope.dutyNo = dutyNo;
        $scope.dutyDay = dutyDay;
        $scope.firstFlightId = getFirstFlightId();      
  
        /**
        * Get the flightId from the first leg of the route
        */
        function getFirstFlightId(){
            var flightId = null;
            if(flights.length > 0){
                flightId = flights[0].FlightId;
            }
            return flightId;
        }

       /**
        * Checks if two dates have the same day
        * @param {string} day1 
        * @param {string} day2 
        */
        function differentDay(day1, day2){
            day1 = new Date(day1).trimTime().getDay();
            day2 = new Date(day2).trimTime().getDay();
            return (day1==day2) ? false : true;
        }

        /**
         * Moves pager to previous page
         */
        function previous(){
            if($scope.currentPage != 1)
                $scope.currentPage--;
        }

        /**
         * Moves pager to next page
         */
        function next(){
            if($scope.currentPage != crewRoute.length)
                $scope.currentPage++;
        }

        /**
         * Opens refresh modal
         */
        function openRefresh(){    
            var modalInstance = $uibModal.open({
                templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
                controller: 'CrewRouteRefreshModalCtrl',
                backdrop: 'static',
                keyboard: false,
                size: 'md',
                resolve: {
                    crewroute: function () { return $scope.crewRoute}, 
                    crewRouteDuty: function () { return  $scope.crewRouteDuty; },
                    dutyNo: function () { return  Number(dutyNo) },
                    dutyDay: function () { return  Number(dutyDay) },
                    forCurrentDay: function() { return null}
                    }
                });
               
                modalInstance.result.then(function (transferData) {
                    if(transferData.sync){
                        SyncLogFactory.forceSync();
                        $location.path("/");            //crew route has significantly changed
                    }
                    else if(transferData.refresh){
                        $route.reload();                //crew route was updated
                    }
                });
        }
    }
    })();
